import { render, staticRenderFns } from "./LessonProcessDisplay.vue?vue&type=template&id=6b1a3056&scoped=true&"
import script from "./LessonProcessDisplay.vue?vue&type=script&lang=js&"
export * from "./LessonProcessDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a3056",
  null
  
)

export default component.exports